import '@babel/polyfill'
import Vue from 'vue'
import '@/plugins/axios'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import lodash from 'lodash'
import VeeValidate from 'vee-validate'
import moment from 'vue-moment'
import CKEditor from 'ckeditor4-vue'
import headersUtil from '@/utils/headersUtil' // 헤더 공통
import customSortUtil from '@/utils/customSortUtil' // 헤더 공통

import LoadScript from 'vue-plugin-load-script'
import VueRecaptcha from 'vue-recaptcha'

import vuetify from '@/plugins/vuetify'
import '@/assets/scss/common.scss'
import '@/assets/scss/h_sub.scss'

// error text overide 처리 함.
import ar from 'vee-validate/dist/locale/ar.js'
import en from 'vee-validate/dist/locale/en.js'
ar.messages.required = () => ' مطلوب'
en.messages.required = () => 'This field is required'

// 로그인 화면 ID 저장
import VueCookies from 'vue-cookies'

// Lodash window 전체 영역 부여
window._ = lodash

Vue.config.productionTip = false

Vue.use(VeeValidate, {
  locale: 'ar'
})
Vue.use(moment)
Vue.use(CKEditor)

Vue.use(headersUtil) // 헤더 공통
Vue.use(customSortUtil)  // 헤더 공통

Vue.use(VueCookies) // 로그인 아이디 저장
Vue.$cookies.config('30d'); // 저장 기간 일단 30일로 지정.

Vue.use(LoadScript)

Vue.loadScript("https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit").then(() => {
  Vue.use(VueRecaptcha)
}).catch((e) => {
  console.error(`google api load failed: ${e.message}`)
})

new Vue({
  router,
  store,
  i18n,
  VeeValidate,
  moment,
  CKEditor,
  vuetify,
  headersUtil,
  customSortUtil,
  VueCookies,
  VueRecaptcha,
  render: h => h(App)
}).$mount('#app')
